export const USER_PRIVATE = "/users/private/";
export const USER_PUBLIC = "/users/public/";
